import {RootStore} from '../RootStore';
import {RootStoreState} from '../RootStoreState';

export const fetchClientRenderingData = async (
  rootStore: RootStore,
): Promise<Pick<RootStoreState, 'contextualProducts' | 'referringPageId' | 'referringPagePath'>> => {
  const [contextualProducts, referringPageId, referringPagePath] = await Promise.all([
    rootStore.ecomPublicApi.product.getContextualProducts(),
    rootStore.ecomPublicApi.product.getReferringPageId(),
    rootStore.ecomPublicApi.product.getReferringPagePath(),
  ]);
  return {
    contextualProducts,
    referringPageId,
    referringPagePath,
  };
};
